import { getUserSubscriptionsStatus } from "../services/addOnsService";


/**
* extend the addons with payment information 
* @public
*/
export function makeAddOnsDeep() {
    const {
        applicationState: { userLogged, addons },
        stateActions: { setAddons }
    } = this.props;
    if (userLogged) {
    getUserSubscriptionsStatus().then(response => {
        return enhanceUserAddons(response, addons, setAddons);
    }).catch(error => {
        console.log('deep call fail', error)
    });
    }
}

/**
* Return user addOns including planId
* @param {String} deepAddOns addons get from api including payment information
* @param {String} userAddOns already stored user addons in the Context API
* @param {String} setAddons to set updated addons in the Context API 
* @return {Array} Return user addOns + planId
*/
export function enhanceUserAddons(deepAddOns, userAddOns, setAddons) {
    const updatedUserAddOns = userAddOns.map(userAddOn => {
        let obj = {}
        deepAddOns.forEach(deepAddOn => {
            if (userAddOn.name.toLowerCase() === deepAddOn.subscriptionName.toLowerCase()) {
                obj = {
                    ...userAddOn,
                    // TODO: extend this object on your need with payment Information
                    planId: deepAddOn.paymentMethod.paymentMethodParams['planId'] || 0
                }
            }
        });
        return obj;
    });

    setAddons(updatedUserAddOns);
    return updatedUserAddOns;
}

